import NotebookGradeByMenu from './NotebookGradeByMenu';

export default NotebookGradeByMenu;
